import { inject, Injectable } from '@angular/core';
import { gReCaptcha, gReCaptchaTheme, gReCaptchaToken } from '@core/data-access/models/recaptcha.model';
import { Language } from '@ngx-translate/core';
import { FormsService } from '@shared/forms/forms.service';
import { StepsFormsActionName } from '@store/step-forms/step.interface';
import { isEmpty } from 'lodash';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReCaptcha {
  readonly #formsService = inject(FormsService);

  #gReCaptchaToken: gReCaptchaToken = '';

  readonly #isReCaptchaValid$ = new BehaviorSubject(false);

  get token() {
    return this.#gReCaptchaToken;
  }

  get isReCaptchaValid$() {
    return this.#isReCaptchaValid$.asObservable();
  }

  setIsReCaptchaValid(greCaptchaToken: gReCaptchaToken) {
    const isReCaptchaValid = !isEmpty(greCaptchaToken);

    this.#gReCaptchaToken = isReCaptchaValid ? greCaptchaToken : '';

    this.#isReCaptchaValid$.next(isReCaptchaValid);
  }

  resetIsReCaptchaValid() {
    this.#gReCaptchaToken = '';

    this.#isReCaptchaValid$.next(false);
  }

  render(
    gReCaptcha: gReCaptcha,
    elementId: string,
    googleReCaptchaSiteKey: string,
    languageCode: Language,
    theme: gReCaptchaTheme
  ) {
    gReCaptcha.render(elementId, {
      sitekey: googleReCaptchaSiteKey,
      hl: languageCode,
      theme,
      callback: this.setIsReCaptchaValid.bind(this),
      'expired-callback': this.resetIsReCaptchaValid.bind(this),
      'error-callback': this.resetIsReCaptchaValid.bind(this)
    });
  }

  setReCaptchaFeedbackMessage(isReCaptchaValid: boolean, stepsFormsActionName: StepsFormsActionName) {
    isReCaptchaValid
      ? this.#formsService.removeStepValidationFeedback(stepsFormsActionName, 'reCaptcha')
      : this.#formsService.addStepValidationFeedback(
          stepsFormsActionName,
          'reCaptcha',
          'validation.feedback-message.recaptcha'
        );
  }
}
